import React, { useState, Fragment, useRef, useEffect } from "react";
import Layout from "../component/common/Layout/Layout";

import Icon from "@mdi/react";
import {
  mdiArrowDownThin,
  mdiArrowUpThin,
  mdiVolumeHigh,
  mdiStopCircleOutline,
} from "@mdi/js";
import ActiveVehicleChart from "../component/common/Chart/ActiveVehicleChart";
import Header from "../component/common/Header/Header";
import { useNavigate } from "react-router-dom";
import { UseManageData } from "../context/manageData";
import FleetViewMap from "./FleetViewMapEmpty";
import { Wrapper } from "@googlemaps/react-wrapper";
import EfficiencyModal from "../component/common/popup/EfficiencyModal";

import { Progressbar, DemoRing } from "./Progressbar";
import { UseContextData } from "../context/dateContext";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import Donut3DChartHC from "../component/common/Chart/Donut3DChartHC";
// Import icon form public folder
import gatewayIcon from "../assets/overview_icons/total devices.svg";
import ticketsIcon from "../assets/overview_icons/total tickets.svg";
import nextMonthIcon from "../assets/overview_icons/Next month.svg";
import totalAlertsIcon from "../assets/overview_icons/total alerts.svg";
import alertsContributingIcon from "../assets/overview_icons/Alerts contributing to tickets.svg";
import alertsDistributionIcon from "../assets/overview_icons/Alerts distribution per manufacturer.svg";

import Button from "../components/Button";

const FleetView = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openNotify, setOpenNotify] = useState(false);
  const [openConsumption, setOpenConsumption] = useState(false);

  const [openTire, setOpenTire] = useState(false);
  const [tab, setTab] = useState(1);
  const [modal, setModal] = useState(false);

  const [isSpeaking, setIsSpeaking] = useState(false);
  const [audioObject, setAudioObject] = useState();

  const { stateData, setStateData } = UseManageData();
  const { isDarkTheme, setIsDarkTheme, selectedLanguage } = UseContextData();
  const [graphSelection, setgraphSelection] = useState("");
  const mapKey = process.env.REACT_APP_VITE_MAP_KEY;

  const IndexValue = useRef(1);
  const dispatch = useDispatch();
  const dataIntervalRef = useRef(null);
  const { t, i18n } = useTranslation();

  const [openForm, setOpenForm] = useState(false);

  // const [selectedLanguage, setSelectedLanguage] = useState("English");
  // const [selectedLanguageImroveNow, setSelectedLanguageImroveNow] =
  // useState("English");

  return (
    <Layout>
      <div className="flex flex-col h-full p-5 gap-5 dark:bg-[#1d1d1d] ">
        <div className="rounded-lg  bg-box-pattern dark:bg-box-pattern2  grid grid-cols-3 gap-3 p-5">
          <ProgressCard />
          <DevicesCard />
          <TicketsCard />
        </div>
        <div className="rounded-lg  bg-box-pattern dark:bg-box-pattern2  grid grid-cols-3 gap-3 p-5">
          <MapCard modal={modal} mapKey={mapKey} />
          <AlertDistributionCard />
          <AlertsContributingTicketsCard />
        </div>
      </div>
    </Layout>
  );
};

export default FleetView;

const AlertDistribution = () => {
  const [item, setItem] = useState("zte");
  const testData1 = [
    // Inactiv device alert
    ["SDMC", 15950],
    ["ZTE", 25044],
  ];

  const testData2 = [
    // Idle user alert
    ["SDMC", 10653],
    ["ZTE", 11935],
  ];
  const testData3 = [
    // Latency packet loss alert
    ["SDMC", 9851],
    ["ZTE", 12714],
  ];
  const testData4 = [
    // Frequent periodic alert
    ["SDMC", 634],
    ["ZTE", 10618],
  ];
  const items = [
    {
      label: "ZTE",
      value: "zte",
      // icon: <UserOutlined />,
    },
    {
      label: "SDMC",
      key: "sdmc",
      // icon: <UserOutlined />,
    },
  ];
  return (
    <div className="flex flex-col h-full">
      <div className="flex justify-between items-center"></div>

      <div className="grid grid-cols-2">
        <div>
          <Donut3DChartHC data={testData1} />
          <h2 className="mt-2 text-sm text-center dark:text-white">
            Inactive Device Alert
          </h2>
        </div>
        <div>
          <Donut3DChartHC data={testData2} />
          <h2 className="mt-2 text-sm text-center dark:text-white">
            Idle User Alert
          </h2>
        </div>
        <div>
          <Donut3DChartHC data={testData3} />
          <h2 className="mt-2 text-sm text-center dark:text-white">
            Latency Packet Loss Alert
          </h2>
        </div>
        <div className="dark:bg-gray-800">
          <Donut3DChartHC data={testData4} />
          <h2 className="mt-2 text-sm text-center dark:text-white">
            Frequent Periodic Alert
          </h2>
        </div>
      </div>
    </div>
  );
};

const TotalTicketsCard = () => {
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 bg-white dark:bg-[#444444] rounded-lg shadow-xl">
      {/* Primera columna */}
      <div className="flex flex-col justify-between">
        <div className="flex ">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Total Tickets"}
          </span>
          <img src={ticketsIcon} className="w-6 ml-2" alt="ticket" />
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          2342{" "}
          <sub className="text-secondary text-xs dark:text-white">Tickets</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={0}
          value={0.14}
          label="vs last month"
        />
      </div>

      {/* Segunda columna */}
      <div className="flex flex-col justify-between">
        <div className="flex">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Next month"}
          </span>
          <img src={nextMonthIcon} className="w-5 ml-2" alt="next-month" />
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          2512{" "}
          <sub className="text-secondary text-xs dark:text-white">Tickets</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={0}
          value={0.07}
          label="vs current month"
        />
      </div>
    </div>
  );
};

const TotalAlertsCard = () => {
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 bg-white dark:bg-[#444444] rounded-lg shadow-xl">
      {/* Primera columna */}
      <div className="flex flex-col justify-between">
        <div className="flex ">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Total Alerts"}
          </span>
          <div>
            <img
              src={totalAlertsIcon}
              className="w-6 ml-2"
              alt="total-alerts"
            />
          </div>
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          80957{" "}
          <sub className="text-secondary text-xs dark:text-white">Alerts</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={0}
          value={2.47}
          label="vs last month"
        />
      </div>

      {/* Segunda columna */}
      <div className="flex flex-col justify-between">
        <div className="flex">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Next month"}
          </span>
          <div>
            <img src={nextMonthIcon} className="w-5 ml-2" alt="next-month" />
          </div>
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          89353{" "}
          <sub className="text-secondary text-xs dark:text-white">Alerts</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={0}
          value={10.37}
          label="vs current month"
        />
      </div>
    </div>
  );
};

const TimeToResolveCard = () => {
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 bg-white dark:bg-[#444444] rounded-lg shadow-xl">
      {/* Primera columna */}
      <div className="flex flex-col justify-between">
        <div className="flex ">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Avg. time to resolve tickets"}
          </span>
          {/* <img src={ticketsIcon} className="w-6 ml-2" alt="ticket" /> */}
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          36 <sub className="text-secondary text-xs dark:text-white">Days</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={0}
          value={1.64}
          label="vs last month"
        />
      </div>

      {/* Segunda columna */}
      <div className="flex flex-col justify-between">
        <div className="flex">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Next month"}
          </span>
          <img src={nextMonthIcon} className="w-5 ml-2" alt="next-month" />
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          35 <sub className="text-secondary text-xs dark:text-white">Days</sub>
        </div>
        <PercentIndicator
          up={0}
          positive={1}
          value={2.78}
          label="vs current month"
        />
      </div>
    </div>
  );
};

const TicketsResolutionCard = () => {
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 bg-white dark:bg-[#444444] rounded-lg shadow-xl">
      {/* Primera columna */}
      <div className="flex flex-col justify-between">
        <div className="flex ">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Tickets resolved within 24h"}
          </span>
          {/* <img src={ticketsIcon} className="w-6 ml-2" alt="ticket" /> */}
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          43{" "}
          <sub className="text-secondary text-xs dark:text-white">Tickets</sub>
        </div>
        <PercentIndicator
          up={1}
          positive={1}
          value={1.84}
          label="vs last month"
        />
      </div>

      {/* Segunda columna */}
      <div className="flex flex-col justify-between">
        <div className="flex">
          <span className="font-bold text-md text-dark dark:text-white">
            {"Next month"}
          </span>
          <img src={nextMonthIcon} className="w-5 ml-2" alt="next-month" />
        </div>

        <div className="text-dark font-medium text-xl dark:text-white">
          42{" "}
          <sub className="text-secondary text-xs dark:text-white">Tickets</sub>
        </div>
        <PercentIndicator
          up={0}
          positive={0}
          value={2.33}
          label="vs current month"
        />
      </div>
    </div>
  );
};

const AlertsContributingTicketsCard = () => {
  const alertsData = [
    {
      label: "Frequent Value Changes Alert",
      percent1: "40.21%",
      percent2: "42.21%",
      change: 2,
      up: 1,
      positive: false,
    },
    {
      label: "Idle User Alert",
      percent1: "28.12%",
      percent2: "30.12%",
      change: 2,
      up: 1,
      positive: false,
    },
    {
      label: "Power Level Limit Alert",
      percent1: "7.04%",
      percent2: "10.04%",
      change: 3,
      up: 1,
      positive: false,
    },
    {
      label: "Response Time Alert",
      percent1: "4.39%",
      percent2: "2.39%",
      change: 2,
      up: 0,
      positive: true,
    },
    {
      label: "Frequent Factory Reset Alert",
      percent1: "3.95%",
      percent2: "1.95%",
      change: 2,
      up: 0,
      positive: true,
    },
    {
      label: "Others",
      percent1: "15.66%",
      percent2: "12.66%",
      change: 3,
      up: 0,
      positive: true,
    },
  ];

  return (
    <div className="rounded-lg flex flex-col items-center gap-4 p-4 bg-white dark:bg-[#444444] relative shadow-md">
      <div className="flex gap-4">
        <img src={alertsContributingIcon} className="w-8" alt="alert-dist" />

        <div className="h1 dark:text-white">Alerts Contributing to Tickets</div>
      </div>
      <div className="flex flex-col w-full my-1 dark:bg-[#444444]  rounded-md px-4">
        {/* Header for Today and Next Month */}
        <div className="flex justify-between items-center py-2">
          <div className="w-1/2"></div>
          <div className="text-dark text-sm font-bold dark:text-white text-left ">
            Today
          </div>
          <div className="text-dark text-sm font-bold dark:text-white text-right ml-5">
            Next Month
          </div>
          <div className="w-[30px]"></div> {/* Columna adicional vacía */}
        </div>

        {/* Mapping through alertsData */}
        {alertsData.map(
          ({ label, percent1, percent2, change, up, positive }, index) => (
            <div key={index} className="flex justify-between items-center py-2">
              <div className="text-dark text-sm font-medium dark:text-white w-1/2">
                {label}:
              </div>
              <div className="text-dark font-medium text-xl dark:text-white text-right w-1/3">
                {percent1}
              </div>
              <div className="text-dark font-medium text-xl dark:text-white text-right w-1/3">
                {percent2}
              </div>
              <div className="w-1/6 flex justify-center">
                <PercentIndicator
                  label=""
                  value={change}
                  up={up}
                  positive={positive}
                />
              </div>
            </div>
          )
        )}
      </div>
      <Button> Take Action </Button>
    </div>
  );
};

const ProgressCard = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-col justify-between items-center">
      <h2 className="mt-5 h1 dark:text-white">Prediction of Tickets</h2>

      <div className="flex flex-col justify-center items-center">
        <Progressbar />
        <PercentIndicator up={1} positive={false} value={4} />
      </div>
      <div>
        <Button onClick={() => setOpen(!open)}>
          <span>Improve Now</span>
          <img src="/assets/icons/rightArrow.svg" alt="rightArrow" />
        </Button>
      </div>

      <EfficiencyModal open={open} setOpen={() => setOpen(!open)} />
    </div>
  );
};

const PercentIndicator = ({
  up = true,
  positive = true,
  value = 0,
  label = "vs last month",
}) => {
  const arrowColor = positive ? "text-green-500" : "text-red-500";

  return (
    <div className="flex items-center">
      <div className="flex items-center">
        <Icon
          path={up ? mdiArrowUpThin : mdiArrowDownThin}
          size={1}
          className={`${arrowColor}`}
        />
        <span className={`${arrowColor} text-sm font-bold`}>{value}%</span>
      </div>

      <div className="text-secondary ml-2 text-xs">{label}</div>
    </div>
  );
};
const DevicesCard = () => {
  return (
    <div className="flex flex-col h-full justify-between items-center space-y-4">
      {/* Total Devices */}
      <div className="w-full p-4 flex items-center justify-between bg-white dark:bg-[#444444] shadow-xl rounded-lg">
        <div className="font-bold text-dark dark:text-white">Total Devices</div>
        <div className="flex items-center gap-2">
          <div className="text-dark font-medium text-2xl dark:text-white">
            23770
          </div>
          <div>
            <img src={gatewayIcon} alt="gateway" />
          </div>
          {/* Icono de dispositivo (comentado por si se utiliza) */}
          {/* <img src="/assets/icons/car.svg" alt="caricon" className="p-2" /> */}
        </div>
      </div>

      {/* Distribución y Active Devices */}
      <div className="flex w-full gap-4 h-full">
        {/* Distribución */}
        <div className="p-4 bg-white rounded-lg w-1/2 shadow-xl dark:bg-[#444444] flex flex-col gap-4">
          <div className="font-bold text-dark mb-4 dark:text-white">
            Distribution
          </div>
          <div className="flex-grow flex">
            <div className="h-full w-3 relative">
              <div className="h-[54.14%] w-1.5 bg-[#4318FF]"></div>
              <div className="h-[45.86%] w-1.5 bg-[#6AD2FF] mt-auto"></div>
            </div>
            <div className="h-full flex-grow pl-2">
              <div className="h-[54.14%] font-bold text-dark mb-4 dark:text-white">
                ZTE <span className="font-medium">54.14%</span>
              </div>
              <div className="h-[45.86%] font-bold text-dark mb-4 dark:text-white">
                SDMC <span className="font-medium">45.86%</span>
              </div>
            </div>
          </div>
          {/* Botón Device Profile */}
          {/* <button className="mt-4 px-4 py-2 bg-[#5DA3E9] text-white text-[16px] font-bold w-full rounded-md flex items-center justify-center gap-4">
            Device Profile
          </button> */}
          <Button>
            <span>Device Profile</span>
          </Button>
        </div>

        {/* Active Devices */}
        <div className="flex flex-col gap-4 flex-grow justify-between">
          <div className="p-4 bg-white rounded-lg  shadow-xl dark:bg-[#444444] flex flex-col flex-grow">
            <div className="font-bold text-dark mb-4 dark:text-white">
              Active Devices
            </div>
            <div className="flex-grow">
              <div className="text-dark font-medium text-2xl dark:text-white">
                16639
              </div>
              <PercentIndicator up={1} value={4} />
            </div>
          </div>
          <div className="p-4 bg-white rounded-lg shadow-xl dark:bg-[#444444] flex flex-col">
            <div className="font-bold text-dark mb-4  dark:text-white ">
              Total Carbon Savings
            </div>
            <div className="flex flex-col gap-4">
              <div className="text-dark font-medium text-2xl dark:text-white">
                150 <span className="text-secondary text-xs">Tons</span>
                <PercentIndicator up={1} value={4} label="vs last month" />
              </div>

              <Button>
                <span>Redeem</span>
              </Button>
              <Button>
                <span>Save More</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TicketsCard = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 flex-1">
        <TotalTicketsCard />
        <TotalAlertsCard />
      </div>

      <div className="flex gap-4 flex-1">
        <TimeToResolveCard />
        <TicketsResolutionCard />
      </div>
    </div>
  );
};

const MapCard = ({ mapKey, modal }) => {
  return (
    <Wrapper apiKey={mapKey} libraries={["places"]}>
      <FleetViewMap modal={modal} />
    </Wrapper>
  );
};

const AlertDistributionCard = () => {
  return (
    <div className="flex flex-col items-center gap-4 w-full relative dark:bg-[#444444] bg-white rounded-lg p-4 ">
      <div className="flex gap-4">
        <img src={alertsDistributionIcon} className="w-8" alt="alert-dist" />
        <div className="h1 dark:text-white">
          Alert Distribution per Manufacturer
        </div>
      </div>
      <AlertDistribution />
      <div className="mt-2 px-10 py-2 bg-white shadow-l dark:bg-[#444444] text-dark text-md dark:text-white font-medium rounded-lg w-full text-center">
        <p>Total number of Alerts: 39,205</p>
      </div>
    </div>
  );
};
